module.exports = __webpack_public_path__ + "static/media/todo.05a173a8.PNG";